module.exports = __webpack_public_path__ + "img/手机外接脚型扫描仪.618b4059.png";